import { postSpecBrochure } from '../../leadGenerators/index';
import { shortFormatBookingDateTime } from '../utils/dateFormatters';

/**
 * Post the Self-guided tour lead based on the tour data.
 * @param user
 * @param specs
 * @param selectedSlot
 */
export default function postSelfGuidedTourLead(user, specs, selectedSlot) {
    const dateFormatted = shortFormatBookingDateTime(selectedSlot.UtcDate, selectedSlot.SpecTimezoneIANAId);

    postSpecBrochure({
        specList: specs,
        specId: specs[0],
        userPhoneNumber: user.phoneNumber,
        mailAddress: user.email,
        name: user.firstName + ' ' + user.lastName,
        fromPage: 'SelfGuidedTour.Modal.Spec',
        leadAction: 'BookSelfGuidedTour',
        type: 'postSelfGuidedTourLead',
        comments: `Date: ${dateFormatted} ${selectedSlot.SpecTimezoneCode}`,
    });
}
